import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className, ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, delay, ease: [0.215, 0.61, 0.355, 1] }}
    {...rest}
  >
    {children}
  </motion.div>
);

export default Reveal;
